import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom currency icon showing "L" in a circle,
 * styled to match MUI icons (supports sx, fontSize, color).
 */
const CurrencyIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <text
      x="12"
      y="16.5"
      textAnchor="middle"
      fontSize="13"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      fill="currentColor"
    >
      L
    </text>
  </SvgIcon>
);

export default CurrencyIcon;
